import styled from 'styled-components';
import BasedModal from "components/BaseModalComponents/BasedModal";
import SideDropdown from "components/SideDrop/SideDropdown";
import {PlusIcon} from "assets/images";
import { IProps } from '../SideDropdown'

export const Search = styled.input`
  display: flex;
  flex-direction: column;
`;

export const LayoutSideDropdown = styled(SideDropdown)<IProps>`
  height: 666px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DropTabDiv = styled.div`
  border-bottom: solid 1px;
  border-color: ${(props) => props.theme.color.lightGreen};
  padding: 10px 0;
  cursor:pointer;
  transition: 0.2s;

  display:flex;
  justify-content:space-between;

  span:hover {
    transition: 0.2s;
    //filter: brightness(84%);
    //transform: translate(10px)
  }
`;

export const CustomBasedModal = styled(BasedModal)`
  width: 250px;
  height: 350px;
`;

export const CustomPlusIcon = styled(PlusIcon)`
  cursor: pointer;
  :hover {
    filter: brightness(80%);
  }
`;



